import { render } from "./positions.vue?vue&type=template&id=7f4e2740&scoped=true&ts=true"
import script from "./positions.vue?vue&type=script&lang=ts"
export * from "./positions.vue?vue&type=script&lang=ts"

import "./positions.vue?vue&type=style&index=0&id=7f4e2740&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f4e2740"]])

export default __exports__